angular.module('SpidApp')

.filter('shortRole', function () {
    return function (input) {
        if (input.length === 0) {
            return ''
        }

        if (input.length === 1) {
            return input[0]
        }

        return input[0] + input[1]
    }
})
